module.exports = __webpack_public_path__ + "img/time.1fe84c67.svg";